import { Range } from 'rc-slider';
import styled from 'styled-components';

export const StyledRange = styled(Range)`
  & > .rc-slider-track,
  & > .rc-slider-handle {
    background-color: ${({ theme }) => theme.primaryBackgroundColor};
    border: none !important;
  }

  & > .rc-slider-handle-dragging {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.primaryBackgroundColor} !important;
  }
`;
